import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';

import ggForm, { FormComponent_Voucher as FormComponentVoucher } from 'ggApp/modules/form';
import {
    submitVoucher as submitVoucherAction,
    resetVoucher as resetVoucherAction,
} from 'ggApp/modules/order/actions';

import { checkCampaignProducts } from 'ggApp/modules/order/utils';

@connect(
    createStructuredSelector({
        reduxForms: ggForm.selectors.reduxForm,
    }),
    (dispatch) => ({
        submitVoucher: bindActionCreators(submitVoucherAction, dispatch),
        resetVoucher: bindActionCreators(resetVoucherAction, dispatch),
    }),
)
class OrderVoucherConnect extends Component {
    render() {
        const { reduxForms, order, submitVoucher, resetVoucher } = this.props;
        const orderHasCampaignProducts = checkCampaignProducts(order);
        return order && order.voucher ? (
            <FormComponentVoucher
                currencySymbol={order.currencySymbol}
                voucherFormValues={reduxForms.voucherForm && reduxForms.voucherForm.values}
                submitVoucher={(values) => submitVoucher(order.number, values.voucher.name)}
                resetVoucher={() => resetVoucher(order.number)}
                initialValues={{
                    voucher: order.voucher,
                    showVoucher:
                        !!order.voucher.name &&
                        !!parseFloat(order.voucher.discount.replace(',', '.')),
                }}
                orderHasPromotion={orderHasCampaignProducts}
            />
        ) : null;
    }
}

export default OrderVoucherConnect;

OrderVoucherConnect.propTypes = {
    reduxForms: PropTypes.shape({
        voucherForm: PropTypes.object,
    }),
    order: PropTypes.shape({
        voucher: PropTypes.object,
        currencySymbol: PropTypes.string,
        number: PropTypes.string,
    }),
    submitVoucher: PropTypes.func,
    resetVoucher: PropTypes.func,
};

OrderVoucherConnect.defaultProps = {
    reduxForms: {},
    order: {},
    submitVoucher: () => {},
    resetVoucher: () => {},
};
